'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccordionContent, AccordionHeader, AccordionItem } from '@lichtblick/photon/organisms/accordion/accordion';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import styles from './calculator-layout.module.scss';
import { CalculatorLayoutTrigger } from './calculator-layout-trigger';
export const CalculatorLayout = ({ children, chip, 'data-testid': dataTestId, headerColor, headline, icon, id, isActionTriggerDisabled })=>{
    const [firstRender, setFirstRender] = useState(true);
    useEffect(()=>{
        setFirstRender(false);
    }, []);
    return /*#__PURE__*/ _jsxs(AccordionItem, {
        className: classNames(styles['accordion-item']),
        "data-testid": dataTestId,
        value: id,
        children: [
            /*#__PURE__*/ _jsx(AccordionHeader, {
                asChild: true,
                "data-testid": "accordion-header",
                children: /*#__PURE__*/ _jsx(CalculatorLayoutTrigger, {
                    actionTriggerDisabled: isActionTriggerDisabled ?? false,
                    chip: chip,
                    color: headerColor,
                    headline: headline,
                    icon: icon
                })
            }),
            /*#__PURE__*/ _jsx(AccordionContent, {
                isAnimationDisabled: firstRender,
                children: children
            })
        ]
    });
};

//# sourceMappingURL=calculator-layout.js.map